"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEditBlock = exports.getCompositionBlocks = void 0;
function addKeyToBlocks(blocks) {
    var result = [];
    blocks.forEach(function (bl) {
        var existingIdCount = result.filter(function (r) { return r.blockId === bl.blockId; }).length;
        result.push(__assign(__assign({}, bl), { key: "".concat(bl.blockId, "-").concat(existingIdCount) }));
    });
    return result;
}
function getCompositionBlocks(list) {
    return addKeyToBlocks(list.blocks);
}
exports.getCompositionBlocks = getCompositionBlocks;
function getEditBlock(compositionBlocks, block) {
    return {
        block: block,
        localBlock: findCompositionBlock(compositionBlocks, block),
    };
}
exports.getEditBlock = getEditBlock;
function findCompositionBlock(compositionBlocks, block) {
    return compositionBlocks.find(function (compositionBlock) { return compositionBlock.blockId === block._id; });
}
//# sourceMappingURL=composition-block-helpers.js.map